const { GET_MEMBER_LIST } = require("src/actions/types");

const initialState = { MemberList: [] };

const MemberListReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_MEMBER_LIST:
      return {
        ...state,
        MemberList: payload,
      };
    default:
      return state;
  }
};

export { MemberListReducer };
